import { BRAND_COLORS } from './pdfConfig';

export const drawFooter = (doc, options = {}) => {
  const {
    companyName = 'therealdevs.pro',
    showPagination = true
  } = options;

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  const totalPages = doc.internal.getNumberOfPages();

  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...BRAND_COLORS.light);

    // Línea sutil
    doc.setDrawColor(...BRAND_COLORS.primary);
    doc.line(15, pageHeight - 15, pageWidth - 15, pageHeight - 15);

    // Texto Izquierdo
    doc.setTextColor(...BRAND_COLORS.black);
    doc.text(`${companyName} - NEXUS CREDIT`, 15, pageHeight - 10);

    // Paginación Derecha
    if (showPagination) {
      const pageText = `Página ${i} de ${totalPages}`;
      doc.text(pageText, pageWidth - 15, pageHeight - 10, { align: 'right' });
    }
  }
};